module.exports = __webpack_public_path__ + "img/李洪利讲师.f2fc865a.png";